import { render, staticRenderFns } from "./PermissoesAcesso.vue?vue&type=template&id=2fe880c2&scoped=true&"
import script from "./PermissoesAcesso.vue?vue&type=script&lang=js&"
export * from "./PermissoesAcesso.vue?vue&type=script&lang=js&"
import style0 from "./PermissoesAcesso.vue?vue&type=style&index=0&id=2fe880c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe880c2",
  null
  
)

export default component.exports